import FacebookLogo from "@/components/icons/FacebookLogo";
import InstagramLogo from "@/components/icons/InstagramLogo";
import TikTokLogo from "@/components/icons/TikTokLogo";
import LinkedInLogo from "@/components/icons/LinkedInLogo";

export default function Logos() {
    return <div className={"flex flex-row flex-wrap justify-start items-center mt-4 gap-4"} >
        <a href={"https://www.facebook.com/calori.fi"} target={"_blank"} className={"cursor-pointer"} >
            <FacebookLogo />
        </a>
        <a href={"https://www.instagram.com/calori.fi"} target={"_blank"} className={"cursor-pointer"} >
            <InstagramLogo />
        </a>
        <a href={"https://www.tiktok.com/@calori.fi"} target={"_blank"} className={"cursor-pointer"} >
            <TikTokLogo />
        </a>
        <a href={"https://www.linkedin.com/company/calori-fi"} target={"_blank"} className={"cursor-pointer"} >
            <LinkedInLogo />
        </a>
    </div>
}